import { render, staticRenderFns } from "./CreateDiscountForCourse.vue?vue&type=template&id=16f893e1&scoped=true"
import script from "./CreateDiscountForCourse.vue?vue&type=script&lang=js"
export * from "./CreateDiscountForCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateDiscountForCourse.vue?vue&type=style&index=0&id=16f893e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f893e1",
  null
  
)

export default component.exports